<div class="score-table" data-crlat="scoreTable" [ngClass]="{ 'only-two-odds-space-lad': !isHomeDrawAwayType }">
    @if (!boxScore) {
        @if (showServingTeam) {
            <div class="score-column serving-team">
                <div class="ball-icon" [class.active]="servingTeams[0]"></div>
                <div class="ball-icon" [class.active]="servingTeams[1]"></div>
            </div>
        }

        @for (item of score; track $index) {
            <div class="score-column" [ngClass]="[isCoralMobile && (item[0] === 'P' || item[0] === 'L') ? 'scoreHPL' : '']" data-crlat="scoreColumn">
                @if (isHeaderShown) {
                    <div
                        class="column-header"
                        [ngClass]="isIP || isHP || isFHPI ? (item[0] === 'P' ? 'column-headerP' : item[0] === 'L' ? 'column-headerL' : '') : ''"
                        [textContent]="item[0]"></div>
                }
                @if (isIP || isHP || isFHPI) {
                    <lazy-component
                        moduleUri="@lazy-modules-module/scoreCard/score-card.module#ScoreCardModule"
                        [inputs]="{
                            scoreClass: scoreClass,
                            item: item,
                            isCoralMobile: isCoralMobile,
                            path: 'odds-card-score',
                            changeStrategy: 'onpush',
                        }"
                        entryComponent="ScoreCardComponent">
                    </lazy-component>
                } @else {
                    <div class="column-values" [ngClass]="scoreClass ? platform : 'scoreH'" [textContent]="item[1]" data-crlat="scoreH"></div>
                    <div class="column-values" [ngClass]="scoreClass ? '' : 'scoreA'" [textContent]="item[2]" data-crlat="scoreA"></div>
                }

                @if (emptyScore) {
                    <div class="column-values emptyScore"></div>
                }
            </div>
        }
    } @else {
        <div class="score-column" data-crlat="scoreColumn">
            @if (scoreHeaders) {
                <div [textContent]="scoreHeaders[0]" class="column-header" [attr.data-crlat]="scoreHeaders[0]"></div>
            }
            <div [textContent]="boxScore.home.inn1" data-crlat="scoreH"></div>
            <div [textContent]="boxScore.away.inn1" data-crlat="scoreA"></div>
        </div>
        <div class="score-column" data-crlat="scoreColumn">
            @if (scoreHeaders) {
                <div [textContent]="scoreHeaders[0]" class="column-header" [attr.data-crlat]="scoreHeaders[0]"></div>
            }
            <div [textContent]="boxScore.home.inn2" data-crlat="scoreH"></div>
            <div [textContent]="boxScore.away.inn2" data-crlat="scoreA"></div>
        </div>
    }
</div>
